import { render, staticRenderFns } from "./popup_toggle_btn.vue?vue&type=template&id=071e6daa&lang=pug&"
import script from "./popup_toggle_btn.vue?vue&type=script&lang=js&"
export * from "./popup_toggle_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports